// PKCE helpers for the Google authorization-code flow (code_challenge_method=S256).

const base64url = (bytes: ArrayBuffer): string =>
  btoa(String.fromCharCode(...new Uint8Array(bytes)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/** Cryptographically random code verifier (43–128 chars, base64url). */
export const randomVerifier = (): string => {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  return base64url(bytes.buffer);
};

/** S256 challenge = base64url(SHA-256(verifier)). */
export const challengeFromVerifier = async (verifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64url(digest);
};
